import { Asterisk } from "lucide-react";
import { MARQUEE_ITEMS } from "../../data";

const Marquee = () => {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div
      className="relative py-10 border-y border-white/10 overflow-hidden mask-fade-x"
      data-testid="editorial-marquee"
    >
      <div className="flex w-max animate-marquee items-center gap-10">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-10 shrink-0">
            <span
              className={`font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tight whitespace-nowrap ${
                i % 2 === 0 ? "text-white" : "text-stroke"
              }`}
            >
              {item}
            </span>
            <Asterisk className="text-blue-500 shrink-0" size={36} />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
